const timelineInterval = 2; // in seconds
const timelineLastHoursInterval = 3; // in seconds

const filters1 = [
  {
    type: 'networkFaults',
    min: 0,
    max: 2000,
  },
  {
    type: 'customersImpacted',
    min: 0,
    max: 250000,
  },
];

const filters2 = [
  {
    type: 'windSpeed',
    min: 0,
    max: 200,
  },
  {
    type: 'windGust',
    min: 0,
    max: 200,
  },
  {
    type: 'temperature',
    min: -25,
    max: 40,
  },
  {
    type: 'precipitation',
    min: 0,
    max: 40,
  },
];

const filtersEventStatus = [
  {
    label: 'Validated',
    value: 'validated',
    checkedByDefault: true,
  },
  {
    label: 'Updating',
    value: 'updating',
    checkedByDefault: true,
  },
  {
    label: 'Pending',
    value: 'pending',
    checkedByDefault: true,
  },
  {
    label: 'Disabled',
    value: 'disabled',
  },
  {
    label: 'Error',
    value: 'error',
  },
];

const temperatureColors = {
  0.0: '#74479F',
  0.15: '#504B9F',
  0.3: '#618B9E',
  0.45: '#689959',
  0.6: '#A19A5C',
  0.75: '#977050',
  0.9: '#804A55',
  1.0: '#9A5178',
};

export {
  timelineInterval,
  timelineLastHoursInterval,
  filters1,
  filters2,
  temperatureColors,
  filtersEventStatus,
};
